import { get } from 'app/utils/axios/kheti'
import { VendorRequest } from 'app/models/RequestFlow'
import ApiResponse from 'app/models/apiResponse'

function buildQueryParams(params: Record<string, any>): string {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => {
        searchParams.append(key, String(v))
      })
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })

  return searchParams.toString()
}

const fetchVendors = async (
  page: number,
  category?: string,
  node_id?: number | number[],
  state_id?: number | number[],
  search_query?: string,
  role_type?: string,
  lang = 'en',
) => {
  try {
    const queryString = buildQueryParams({
      page,
      page_size: 10,
      category,
      node_id,
      state_id,
      search_query,
      role_type,
      lang,
    })

    const response = await get<ApiResponse<VendorRequest>>(
      `/approvals/v1/vendors?${queryString}`,
    )

    return response
  } catch (e) {
    console.log('Error fetching vendor requests:', e)
    return null
  }
}

export default fetchVendors
